export default __webpack_public_path__ + "static/media/uncheck.9cc8bbf6.png";